import { render } from "./Width.svg?vue&type=template&id=229b2e02"
const script = {}
script.render = render

export default script